__turbopack_context__.v({
  "chatButton": "XlPv9W_chatButton",
  "chatButton__dot": "XlPv9W_chatButton__dot",
});
